import { IconButton, Stack, styled, Tooltip, Typography } from '@ethings/ui-toolkit';
import { useTheme } from '@mui/material';
import { FC } from 'react';
import { CacheDataTypes, Display } from '../../types';
import { FetchOne } from '../fetch';
import { FormatTimestamp } from '../format';
import { Icon } from '../icons';
import { JourneyItem } from './entity-journey-types';
import { useHistorySearch } from './use-history-search';
import { getJourneyColor } from './util';

interface Props {
  dataType: CacheDataTypes.THING | CacheDataTypes.PERSON;
  handleDrawerToggle?: (value: boolean) => void;
  journey: JourneyItem;
}

const COLLAPSED_JOURNEY_ITEM_LINES_DISPLAYED = 4;

const StyledIconButton = styled(IconButton)({
  borderRadius: 0,
  width: '100%',
});

const StyledTypography = styled(Typography)({
  color: 'text.primary',
  display: '-webkit-box',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  variant: 'caption',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: COLLAPSED_JOURNEY_ITEM_LINES_DISPLAYED,
});

export const MinimizedJourney: FC<Props> = ({
  dataType,
  handleDrawerToggle,
  journey,
}) => {
  const { handleExpand } = useHistorySearch();
  const theme = useTheme();

  return <>
    <Tooltip
      arrow
      placement="right"
      title={
        <Typography variant="caption">
          <FormatTimestamp format="short" value={journey.dateRange.startTime} /> - <FormatTimestamp format="short" value={journey.dateRange.endTime} />
        </Typography>
      }
    >
      <StyledIconButton
        data-testid="map-pin-button"
        onClick={() => {
          handleDrawerToggle?.(true);
          handleExpand(journey.entityId, journey.id);
        }}
      >
        <Stack alignItems="center">
          <Icon data-testid="map-pin-icon" icon="MapPin" style={{ color: getJourneyColor(journey.colorIndex, theme), fontSize: '2rem' }} />
          <FetchOne
            id={journey.entityId}
            dataType={dataType}
            renderFactory={(data: Display) => (
              <StyledTypography>
                {data.display}
              </StyledTypography>
            )}
          />
        </Stack>
      </StyledIconButton>
    </Tooltip >
  </>;
};
